/* Site funnel: step cards, background uploads, one POST to n8n, then the
   picks go in the cart and the done screen explains what happens next.
   ?paid=1&e=<email> turns it into the post-purchase intake (no budget card,
   no cart, different done copy). */
(function () {
  function init(root) {
    if (root.dataset.sfReady) return;
    root.dataset.sfReady = '1';

    var qs = new URLSearchParams(location.search);
    var paid = qs.get('paid') === '1';
    var form = root.querySelector('[data-sf-form]');
    var allSteps = Array.prototype.slice.call(root.querySelectorAll('.sf__step'));
    var bar = root.querySelector('[data-sf-progress]');
    var back = root.querySelector('[data-sf-back]');
    var next = root.querySelector('[data-sf-next]');
    var submit = root.querySelector('[data-sf-submit]');
    var enterHint = root.querySelector('[data-sf-enter]');
    var err = root.querySelector('[data-sf-err]');
    var cur = null;
    var uploads = { logo: [], photos: [], proof: [] };   // group -> [{name,url}]
    var pending = 0;
    var submitting = false;
    var sid = 'sf_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
    // Meta match signals (2026-10-05, EMQ fix): fbp/fbc cookies + fbclid, sent to n8n so the server Lead matches the browser one
    function cookieVal(n) { var m = document.cookie.match('(?:^|; )' + n + '=([^;]*)'); return m ? decodeURIComponent(m[1]) : ''; }
    try { var fbclid0 = qs.get('fbclid'); if (fbclid0) sessionStorage.setItem('sf_fbc', 'fb.1.' + Date.now() + '.' + fbclid0); } catch (x) {}
    function fbcVal() { var c = cookieVal('_fbc'); if (c) return c; try { return sessionStorage.getItem('sf_fbc') || ''; } catch (x) { return ''; } }
    function matchData(d) {   // plain values; the pixel hashes them before sending
      var u = {}, em = (d.email || '').trim().toLowerCase(), ph = (d.phone || '').replace(/\D/g, ''), nm = (d.name || '').trim().toLowerCase().split(/\s+/).filter(Boolean);
      if (ph.length === 10) ph = '1' + ph;
      if (em) { u.em = em; u.external_id = em; }
      if (ph.length >= 11) u.ph = ph;
      if (nm[0]) u.fn = nm[0];
      if (nm.length > 1) u.ln = nm[nm.length - 1];
      u.country = 'us';
      return u;
    }
    var pixelInited = false;
    function initPixel(d) {   // ONE init, with advanced matching when we know who they are (a second init of the same id is ignored by Meta)
      var id = root.dataset.pixel;
      if (!id || !window.fbq || pixelInited) return;
      pixelInited = true;
      try { window.fbq('set', 'autoConfig', false, id); window.fbq('init', id, matchData(d || {})); } catch (x) {}
    }

    // data-skip-paid = lead flow only, data-paid-only = post-purchase intake only (look, assets, platform, notes).
    // Works on whole steps and on blocks inside a step.
    root.querySelectorAll(paid ? '[data-skip-paid]' : '[data-paid-only]').forEach(function (s) { s.remove(); });
    allSteps = Array.prototype.slice.call(root.querySelectorAll('.sf__step'));
    if (paid) {
      var e = qs.get('e');
      if (e) form.elements.email.value = e;
    }

    /* ---------- which questions apply right now ---------- */
    function val(name) {
      var boxes = form.querySelectorAll('input[name="' + name + '"]');
      if (boxes.length && (boxes[0].type === 'radio' || boxes[0].type === 'checkbox')) {
        return Array.prototype.filter.call(boxes, function (b) { return b.checked; }).map(function (b) { return b.value; }).join(',');
      }
      var el = form.elements[name];
      return el && !el.length ? (el.value || '').trim() : (el && el.value ? String(el.value).trim() : '');
    }
    function applies(step) {
      var cond = step.dataset.if;
      if (!cond) return true;
      var m = cond.match(/^(\w+)(!?=|~=)(.+)$/);
      if (!m) return true;
      var v = val(m[1]);
      if (m[2] === '~=') return v.split(',').indexOf(m[3]) > -1;
      var eq = v === m[3];
      return m[2] === '=' ? eq : !eq;
    }
    var autoTimer = null;
    function steps() { return allSteps.filter(applies); }

    /* ---------- steps ---------- */
    function show(step, userMoved) {
      var list = steps();
      var i = list.indexOf(step);
      if (i < 0) { step = list[0]; i = 0; }
      cur = step;
      allSteps.forEach(function (s) { s.classList.toggle('is-on', s === step); });
      bar.style.width = Math.round((i / list.length) * 100) + '%';
      root.querySelector('[data-sf-stepname]').textContent = step.dataset.name;
      // the counter only counts questions; proof screens ride along under the question before them
      var qs_ = list.filter(function (s) { return !s.hasAttribute('data-interstitial'); });
      var qi = 0; for (var k = 0; k <= i; k++) if (!list[k].hasAttribute('data-interstitial')) qi++;
      root.querySelector('[data-sf-count]').textContent = Math.max(1, qi) + ' / ' + qs_.length;
      back.hidden = i === 0;
      var last = i === list.length - 1;
      next.hidden = last;
      submit.hidden = !last;
      var auto = step.hasAttribute('data-auto');
      var inter = step.hasAttribute('data-interstitial');
      if (inter && step.querySelector('[data-sf-rec]')) pickTheme(step);
      if (enterHint) enterHint.hidden = auto || last || inter;
      var skipHint = root.querySelector('[data-sf-skip]'); if (skipHint) skipHint.hidden = !inter || step.hasAttribute('data-go-theme');
      next.textContent = step.hasAttribute('data-go-theme') && themeRec ? 'Take me to ' + themeRec.label.replace(' theme', '') + ' →' : (inter ? 'Continue' : 'Next');
      clearTimeout(autoTimer);
      if (inter && !step.hasAttribute('data-no-auto')) {
        // the screen answers what they said they wanted, then moves on by itself
        var secs = parseFloat((getComputedStyle(step).getPropertyValue('--sf-auto') || '9').replace('s', '')) || 9;
        autoTimer = setTimeout(function () { if (cur === step) go(1); }, secs * 1000);
      }
      err.classList.remove('is-on');
      if (step.querySelector('[data-sf-product-list]') && !step.querySelector('[data-sf-product]')) addProduct();
      if (userMoved) {
        // park the question right under the sticky header every time, so the
        // hero scrolls away and each screen reads like the only thing on the page
        var hdr = document.querySelector('sticky-header, .section-header, .shopify-section-group-header-group');
        var off = (hdr ? hdr.getBoundingClientRect().height : 0) + 24;
        var top = form.getBoundingClientRect().top + window.scrollY - off;
        if (Math.abs(window.scrollY - top) > 8) window.scrollTo({ top: top, behavior: 'smooth' });
        var first = step.querySelector('input:not([type=file]):not([type=radio]):not([type=checkbox]), textarea');
        if (first && window.matchMedia('(min-width: 750px)').matches) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (x) { first.focus(); } }, 60);   // plain focus() yanks the page mid smooth-scroll
      }
    }
    function go(delta) {
      var list = steps();
      var i = list.indexOf(cur);
      show(list[Math.max(0, Math.min(i + delta, list.length - 1))], true);
    }

    function validate(step) {
      var bad = null;
      var radios = {};
      step.querySelectorAll('input, select, textarea').forEach(function (el) {
        el.classList.remove('is-bad');
        if (el.type === 'radio') { if (el.required) radios[el.name] = true; return; }
        if (el.type === 'file') return;
        if (el.type === 'checkbox') { if (el.required && !el.checked && !bad) bad = el; return; }
        if (!el.checkValidity()) { el.classList.add('is-bad'); if (!bad) bad = el; }
      });
      Object.keys(radios).forEach(function (n) { if (!step.querySelector('input[name="' + n + '"]:checked') && !bad) bad = step.querySelector('input[name="' + n + '"]'); });
      if (!bad && step.dataset.requireAny) {
        var ok = step.dataset.requireAny.split(',').some(function (n) { return !!val(n); });
        if (!ok) { err.textContent = step.dataset.requireMsg || 'Fill one of these in first.'; err.classList.add('is-on'); var t = step.querySelector('textarea, input:not([type=radio])'); if (t) t.focus(); return false; }
      }
      if (bad) {
        err.textContent = bad.type === 'checkbox' ? 'Tick the terms box to send it.'
                        : bad.type === 'radio' ? 'Pick one to keep going.'
                        : bad.type === 'email' ? 'That email does not look right.'
                        : bad.type === 'url' ? 'Links need to start with https://'
                        : 'This one is needed before we move on.';
        err.classList.add('is-on');
        if (bad.focus && bad.type !== 'radio') bad.focus();
        return false;
      }
      return true;
    }

    next.addEventListener('click', function () {
      if (cur && cur.hasAttribute('data-go-theme') && themeRec) { goTheme(); return; }
      if (validate(cur)) go(1);
    });
    function goTheme() {
      // under $250: the lead still lands in Slack/HubSpot, they just skip straight to the theme
      next.disabled = true; next.textContent = 'One sec…';
      var data = collect();
      data.addons = []; data.cart_total = themeRec.price;
      var dest = '/products/' + themeRec.handle + '?ref=funnel&sf=theme';   // sf=theme, not sf=done: under-$250 must NOT count as a qualified lead in Meta
      var t0 = Date.now(), left = false;
      var leave = function () { if (left) return; left = true; location.href = dest; };
      // give the pixel request ~700ms to leave before the page does
      var leaveSoon = function () { setTimeout(leave, Math.max(0, 700 - (Date.now() - t0))); };
      try { sessionStorage.setItem('sf_done', data.email); localStorage.removeItem(KEY); } catch (x) {}
      pixel([themeRec], themeRec.price, false, data);
      // budget is question 1 now, so an under-$250 visitor usually hasn't given contact info: nothing to send to n8n
      if (!data.email && !data.phone) leaveSoon();
      else fetch(root.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data), keepalive: true })
        .then(leaveSoon, leaveSoon);
      setTimeout(leave, 2500);
    }
    back.addEventListener('click', function () { clearTimeout(autoTimer); go(-1); });
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && !next.hidden) { e.preventDefault(); next.click(); }
    });
    // single-choice tiles move on by themselves, like a real conversation
    allSteps.forEach(function (step) {
      if (!step.hasAttribute('data-auto')) return;
      step.querySelectorAll('input[type=radio]').forEach(function (r) {
        r.addEventListener('change', function () { if (step === cur) setTimeout(function () { if (validate(step)) go(1); }, 220); });
      });
    });

    /* ---------- products repeater ---------- */
    var prodList = root.querySelector('[data-sf-product-list]');
    var prodTpl = root.querySelector('[data-sf-product-tpl]');
    function addProduct() {
      var node = prodTpl.content.firstElementChild.cloneNode(true);
      node.querySelector('[data-sf-pn]').textContent = prodList.children.length + 1;
      node.querySelector('[data-sf-remove]').addEventListener('click', function () {
        node.remove();
        Array.prototype.forEach.call(prodList.children, function (p, n) { p.querySelector('[data-sf-pn]').textContent = n + 1; });
      });
      node._files = [];
      wireDrop(node.querySelector('[data-sf-drop]'), node.querySelector('.sf__files'), node._files);
      prodList.appendChild(node);
    }
    var addBtn = root.querySelector('[data-sf-add-product]');
    if (addBtn) addBtn.addEventListener('click', addProduct);

    /* ---------- uploads ---------- */
    var MAX = (parseFloat(root.dataset.maxMb) || 15) * 1024 * 1024;

    function shrink(file) {
      // Photos come off phones at 4-8MB. Downscale to 2000px so they clear the
      // webhook cap and upload in a second; logos and anything non-raster pass through.
      if (!/^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type) || file.size < 1.5 * 1024 * 1024) return Promise.resolve(file);
      return new Promise(function (res) {
        var img = new Image();
        var url = URL.createObjectURL(file);
        img.onload = function () {
          var s = Math.min(1, 2000 / Math.max(img.width, img.height));
          var c = document.createElement('canvas');
          c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
          c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
          c.toBlob(function (b) {
            URL.revokeObjectURL(url);
            if (!b) return res(file);
            res(new File([b], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }));
          }, 'image/jpeg', 0.86);
        };
        img.onerror = function () { URL.revokeObjectURL(url); res(file); };
        img.src = url;
      });
    }

    function upload(file, group, li, store) {
      pending++;
      li.classList.add('is-busy');
      return shrink(file).then(function (f) {
        if (f.size > MAX) throw new Error('too big — use the Drive link instead');
        var fd = new FormData();
        fd.append('file', f, f.name);
        fd.append('group', group);
        fd.append('email', (form.elements.email.value || '').trim().toLowerCase());
        fd.append('sid', sid);
        return fetch(root.dataset.upload, { method: 'POST', body: fd }).then(function (r) { return r.json(); });
      }).then(function (j) {
        if (!j || !j.url) throw new Error('upload failed');
        store.push({ name: file.name, url: j.url });
        li.classList.remove('is-busy'); li.classList.add('is-up');
      }).catch(function (e) {
        li.classList.remove('is-busy'); li.classList.add('is-err');
        li.querySelector('span').textContent = file.name + ' · ' + (e.message || 'failed');
      }).then(function () { pending--; });
    }

    function wireDrop(drop, list, store) {
      var input = drop.querySelector('input[type=file]');
      var group = drop.dataset.sfDrop;
      var OK_TYPE = /^(image\/(png|jpeg|webp|heic|heif)|video\/(mp4|quicktime|webm))$/i;
      var OK_EXT = /\.(png|jpe?g|webp|heic|heif|mp4|mov|webm)$/i;
      function take(files) {
        Array.prototype.forEach.call(files, function (file) {
          var li = document.createElement('li');
          if (!(OK_TYPE.test(file.type) || (!file.type && OK_EXT.test(file.name))) || !OK_EXT.test(file.name)) {
            li.className = 'is-err';
            li.innerHTML = '<i></i><span></span><button type="button" aria-label="Remove">×</button>';
            li.querySelector('span').textContent = file.name + ' · PNG, JPG or video only';
            li.querySelector('button').addEventListener('click', function () { li.remove(); });
            list.appendChild(li);
            return;
          }
          li.innerHTML = '<i></i><span></span><button type="button" aria-label="Remove">×</button>';
          li.querySelector('span').textContent = file.name;
          li.querySelector('button').addEventListener('click', function () {
            li.remove();
            for (var k = store.length - 1; k >= 0; k--) if (store[k].name === file.name) store.splice(k, 1);
          });
          list.appendChild(li);
          upload(file, group, li, store);
        });
      }
      input.addEventListener('change', function () { take(input.files); input.value = ''; });
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) take(e.dataTransfer.files); });
    }
    root.querySelectorAll('[data-sf-drop]').forEach(function (d) {
      if (d.closest('template') || d.closest('[data-sf-product]')) return;
      var g = d.dataset.sfDrop;
      wireDrop(d, root.querySelector('[data-sf-files="' + g + '"]'), uploads[g]);
    });

    /* ---------- theme recommendation (budget under $250) ---------- */
    var themeRec = null;
    var SITE_THEME = { 'shelikemyjeans': 'reign', 'visionaryno1': 'reign', 'fnoeuvre': 'reign', 'vilanosixx': 'showcase', 'ricchezza': 'showcase' };
    function pickTheme(step) {
      var liked = val('likes') || '';
      var text = (val('aesthetic') || '').toLowerCase();
      var key = 'skeleton', why = 'Based on the look you described';
      Object.keys(SITE_THEME).forEach(function (k) { if (liked.indexOf(k) > -1) { key = SITE_THEME[k]; why = 'Based on the store you picked'; } });
      if (why !== 'Based on the store you picked') {
        if (/drop|streetwear|hype|limited|countdown|restock|release/.test(text)) key = 'reign';
        else if (/cinematic|editorial|luxury|premium|expensive|video|photo|motion|high[- ]?end|campaign/.test(text)) key = 'showcase';
        else if (/minimal|clean|simple|fast|convert/.test(text)) key = 'skeleton';
        else why = 'The one that fits most brands at this stage';
      }
      var chosen = null;
      step.querySelectorAll('[data-sf-rec]').forEach(function (el) { var on = el.dataset.sfRec === key; el.hidden = !on; if (on) chosen = el; });
      if (!chosen) chosen = step.querySelector('[data-sf-rec]'); if (chosen) chosen.hidden = false;
      if (chosen) {
        var w = chosen.querySelector('[data-sf-rec-why]'); if (w) w.textContent = why;
        themeRec = { key: chosen.dataset.sfRec, id: chosen.dataset.variant, price: +chosen.dataset.price, label: chosen.dataset.name + ' theme', handle: chosen.dataset.handle };
      }
    }

    /* ---------- cart ---------- */
    function picks() {
      var out = [];
      var ds = root.dataset;
      var chosen = Array.prototype.map.call(form.querySelectorAll('input[name="addons"]:checked'), function (c) { return c.value; });
      if (chosen.indexOf('full') > -1) {
        out.push({ key: 'full', id: ds.vFull, price: +ds.pFull, label: 'The Full System' });
        return out;   // the bundle already contains the site and every add-on
      }
      if (val('budget') === 'Under $250' && themeRec) out.push(themeRec);   // the recommendation replaces the build
      else out.push({ key: 'custom', id: ds.vCustom, price: +ds.pCustom, label: 'Custom site build' });
      if (chosen.indexOf('meta') > -1) out.push({ key: 'meta', id: ds.vMeta, price: +ds.pMeta, label: 'Meta ads setup' });
      if (chosen.indexOf('sms') > -1) out.push({ key: 'sms', id: ds.vSms, price: +ds.pSms, label: 'SMS automations' });
      if (chosen.indexOf('email') > -1) out.push({ key: 'email', id: ds.vEmail, price: +ds.pEmail, label: 'Email automations' });
      return out;
    }

    function addToCart(items) {
      var lines = items.filter(function (i) { return i.id; }).map(function (i) { return { id: Number(i.id), quantity: 1 }; });
      if (!lines.length) return Promise.resolve(false);
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: lines })
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    }

    /* ---------- pixel ---------- */
    function loadPixel() {
      var id = root.dataset.pixel;
      if (!id) return;
      try {
        if (!window.fbq) {
          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
          // script loaded up front so the submit event never races a redirect; init waits for the contact info (advanced matching)
          // no PageView - the Shopify channel pixel fires it
        }
      } catch (e) {}
    }
    loadPixel();
    function pixel(items, total, qualified, data) {
      var id = root.dataset.pixel;
      if (!id) return;
      try {
        if (!window.fbq) {
          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
        }
        initPixel(data);
        window.fbq('trackCustom', root.dataset.event || 'CustomSiteLead', {
          content_name: 'custom site funnel', content_ids: items.map(function (i) { return i.key; }),
          value: total, currency: 'USD', paid_mode: paid ? 1 : 0, qualified: qualified ? 1 : 0
        }, { eventID: sid });
        // Arthur's rule: ads optimize on QUALIFIED leads only ($250+ budget). Standard Lead fires only for them,
        // never for under-$250 (sent to themes) or post-purchase intakes.
        if (qualified) window.fbq('track', 'Lead', { content_name: 'custom site - qualified', value: total, currency: 'USD' }, { eventID: sid + '-lead' });
      } catch (e) {}
    }

    /* ---------- submit ---------- */
    function collect() {
      var f = form.elements;
      var v = function (n) { return (f[n] && f[n].value || '').trim(); };
      var products = Array.prototype.map.call(prodList ? prodList.children : [], function (p) {
        var g = function (k) { var el = p.querySelector('[data-pf="' + k + '"]'); return el ? el.value.trim() : ''; };
        return { name: g('name'), price: g('price'), sizes: g('sizes'), stock: g('stock'), desc: g('desc'), files: p._files || [] };
      }).filter(function (p) { return p.name || p.files.length; });
      var items = paid ? [] : picks();
      var total = items.reduce(function (a, b) { return a + (b.price || 0); }, 0);
      var checked = function (n) { var el = form.querySelector('input[name="' + n + '"]:checked'); return el ? el.value : ''; };
      return {
        sid: sid, paid: paid, submitted_at: new Date().toISOString(), page: location.href,
        utm: { source: qs.get('utm_source') || '', campaign: qs.get('utm_campaign') || '', fbclid: qs.get('fbclid') ? 1 : 0 },
        name: v('name'), email: v('email').toLowerCase(), phone: v('phone'),
        brand: v('brand'), ig: v('ig').replace(/^@/, ''), sells: v('sells'), platform: v('platform'), website: v('website'),
        aesthetic: v('aesthetic'), refs: (v('aesthetic').match(/https?:\/\/[^\s,]+/g) || []).concat(Array.prototype.map.call(form.querySelectorAll('input[name="likes"]:checked'), function (c) { return c.value; })), theme: checked('theme'),
        drive: '', has_products: checked('has_products'), products: products,
        assets: uploads,
        budget: paid ? '' : checked('budget'), timeline: paid ? '' : checked('timeline'), goal: val('goal'),
        theme_rec: (!paid && val('budget') === 'Under $250' && themeRec) ? themeRec : null,
        addons: items.map(function (i) { return i.key; }), cart_total: total,
        notes: v('notes'),
        event_id: sid + '-lead', fbp: cookieVal('_fbp'), fbc: fbcVal(), ua: navigator.userAgent
      };
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitting) return;
      var list = steps();
      for (var i = 0; i < list.length; i++) if (!validate(list[i])) { show(list[i], true); return; }
      if (pending > 0) {
        err.textContent = 'Still uploading ' + pending + ' file' + (pending > 1 ? 's' : '') + ' — give it a second.';
        err.classList.add('is-on');
        setTimeout(function () { if (pending === 0) { err.classList.remove('is-on'); form.requestSubmit(); } }, 1200);
        return;
      }
      submitting = true;
      submit.disabled = true;
      submit.textContent = 'Sending…';
      var data = collect();
      var items = paid ? [] : picks();

      fetch(root.dataset.endpoint, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data)
      }).then(function (r) { return r.ok ? r.json().catch(function () { return {}; }) : Promise.reject(new Error('bad response')); })
        .then(function () {
          try { sessionStorage.setItem('sf_done', data.email); localStorage.removeItem(KEY); } catch (x) {}
          pixel(items, data.cart_total, !paid, data);
          return paid ? true : addToCart(items);
        })
        .then(function (inCart) { done(data, items, inCart); })
        .catch(function () {
          submitting = false; submit.disabled = false; submit.textContent = 'Send it';
          err.textContent = 'That did not go through. Try again, or DM @sitesbyseth and I will take it from there.';
          err.classList.add('is-on');
        });
    });

    function done(data, items, inCart) {
      form.hidden = true;
      // stamp the URL so a Meta custom conversion (URL contains sf=done) can count the finish, then send a PageView for it
      try { history.replaceState(null, '', location.pathname + (paid ? '?sf=intake' : '?sf=done')); if (window.fbq) window.fbq('track', 'PageView'); } catch (x) {}   // paid intakes are customers, not leads
      var d = root.querySelector('[data-sf-done]');
      var first = (data.name || '').split(' ')[0];
      root.querySelector('[data-sf-first]').textContent = first ? ', ' + first : '';
      root.querySelector('[data-sf-how-lead]').hidden = paid;
      root.querySelector('[data-sf-how-paid]').hidden = !paid;
      root.querySelector('[data-sf-cta-lead]').hidden = paid;
      root.querySelector('[data-sf-cta-paid]').hidden = !paid;
      if (!paid) {
        var sum = root.querySelector('[data-sf-summary]');
        sum.innerHTML = items.map(function (i) { return '<div class="sf__sum"><span>' + i.label + '</span><span>$' + i.price + '</span></div>'; }).join('')
          + '<div class="sf__sum"><span>Total</span><span>$' + data.cart_total + '</span></div>';
        var btn = root.querySelector('[data-sf-checkout]');
        btn.textContent = (data.theme_rec ? 'Get ' + data.theme_rec.label + ' — $' : 'Lock in your build — $') + data.cart_total;
        // qualified ($250+) custom-site leads: the call is the main ask, checkout is the "skip the call" option
        var call = root.querySelector('[data-sf-call]');
        if (call && !data.theme_rec) {
          var u = call.getAttribute('data-call-url') || '';
          var q = 'name=' + encodeURIComponent(data.name || '') + '&email=' + encodeURIComponent(data.email || '')
            + '&a1=' + encodeURIComponent([data.brand, data.ig].filter(Boolean).join(' · '));
          var cb = call.querySelector('[data-sf-call-btn]');
          cb.href = u + (u.indexOf('?') > -1 ? '&' : '?') + q;
          cb.addEventListener('click', function () { try { if (window.fbq) window.fbq('trackCustom', 'SiteCallClick', { budget: data.budget || '' }, { eventID: sid + '-call' }); } catch (x) {} });
          call.hidden = false;
          d.classList.add('is-call');
          root.querySelector('[data-sf-cta-lead]').classList.add('is-call');
          btn.textContent = 'Lock in your build now — $' + data.cart_total;
          var s2 = root.querySelector('[data-sf-how-step2]');
          if (s2) s2.innerHTML = '<b>Book your 15-min call above.</b><p>I walk you through your site, you lock it in, and the build starts the same day. Or skip the call and lock it in now.</p>';
        }
        if (!inCart) {
          // cart add failed (rare): send them through the permalink so the same items still land
          var ids = items.filter(function (i) { i.id; return i.id; }).map(function (i) { return i.id + ':1'; }).join(',');
          btn.href = ids ? '/cart/' + ids : (data.theme_rec ? '/products/' + data.theme_rec.handle : '/products/custom-website-build-shopify-wix');
          root.querySelector('[data-sf-cart-note]').textContent = 'Your picks load at checkout';
        }
      }
      d.classList.add('is-on');
      var top = root.getBoundingClientRect().top + window.scrollY - 60;
      window.scrollTo({ top: top, behavior: 'smooth' });
      if (window.history && history.replaceState) history.replaceState(null, '', location.pathname + (paid ? '?paid=1' : '') + '#sent');
    }

    // rail clips run muted; a tap turns the sound on for that one and mutes the rest
    root.querySelectorAll('[data-sf-rail-video]').forEach(function (box) {
      box.addEventListener('click', function () {
        var v = box.querySelector('video'); if (!v) return;
        var loud = box.classList.contains('is-loud');
        root.querySelectorAll('[data-sf-rail-video]').forEach(function (o) { o.classList.remove('is-loud'); var ov = o.querySelector('video'); if (ov) ov.muted = true; });
        clearTimeout(autoTimer);
        if (!loud) { box.classList.add('is-loud'); v.muted = false; if (v.preload === 'none') { v.preload = 'auto'; v.load(); } var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });

    root.querySelectorAll('input[name="likes"]').forEach(function (r) { r.addEventListener('change', function () { err.classList.remove('is-on'); }); });
    // proof screens: a tap anywhere that isn't a link moves on
    allSteps.forEach(function (step) {
      if (!step.hasAttribute('data-interstitial')) return;
      if (step.hasAttribute('data-go-theme')) return;   // that one has a real decision on it
      step.addEventListener('click', function (e) { if (e.target.closest('a, button, label, input, [data-sf-rail-video]')) return; if (step === cur) { clearTimeout(autoTimer); go(1); } });
    });
    // the View store link sits inside the pick label; keep its click from flipping the pick
    root.querySelectorAll('[data-sf-site-view]').forEach(function (a) { a.addEventListener('click', function (e) { e.stopPropagation(); }); });

    /* ---------- persist + partial capture ---------- */
    var KEY = 'sf_state_v2';   // v2: step order changed, old saved step indexes would land on the wrong card
    function snapshot() {
      var f = form.elements; var o = {};
      Array.prototype.forEach.call(form.querySelectorAll('input:not([type=file]), select, textarea'), function (el) {
        if (!el.name) return;
        if (el.type === 'radio' || el.type === 'checkbox') { if (el.checked) (o[el.name] = o[el.name] || []).push(el.value); }
        else if (el.value) o[el.name] = el.value;
      });
      o.__step = allSteps.indexOf(cur); return o;
    }
    function persist() { try { localStorage.setItem(KEY, JSON.stringify(snapshot())); } catch (x) {} }
    function restore() {
      var o; try { o = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (x) {}
      if (!o || paid) return;
      Object.keys(o).forEach(function (n) {
        if (n === '__step') return;
        var v = o[n];
        form.querySelectorAll('[name="' + n + '"]').forEach(function (el) {
          if (el.type === 'radio' || el.type === 'checkbox') el.checked = Array.isArray(v) && v.indexOf(el.value) > -1;
          else el.value = v;
        });
      });
      if (o.__step > 0 && allSteps[o.__step]) show(allSteps[o.__step], false);
    }
    form.addEventListener('input', persist); form.addEventListener('change', persist);
    var origGo = go; go = function (d) { origGo(d); persist(); };
    var partialSent = false;
    function partial() {
      if (partialSent || submitting) return;
      var email = (form.elements.email && form.elements.email.value || '').trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return;
      try { if (sessionStorage.getItem('sf_done') === email.toLowerCase()) return; } catch (x) {}
      partialSent = true;
      var o = snapshot(); var list = steps();
      var body = JSON.stringify({ sid: sid, email: email, name: o.name || '', phone: o.phone || '', brand: o.brand || '', ig: o.ig || '', goal: (o.goal || []).join(','), budget: (o.budget || [])[0] || '', step: list.indexOf(cur) + 1, total: list.length, page: location.href });
      try { navigator.sendBeacon(root.dataset.endpoint + '-partial', new Blob([body], { type: 'application/json' })); } catch (x) {}
    }
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') partial(); });
    window.addEventListener('pagehide', partial);

    show(allSteps[0], false);
    restore();
  }

  function boot() { document.querySelectorAll('[data-sf]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
